<template>
  <header class="header">
    <div class="header-inner">
      <div class="logo">
        <img src="../assets/logo.png" @click="homes()" alt="" style="width: 180px;">
      </div>
      
      <!-- 移动端菜单按钮 -->
      <button class="mobile-toggle" @click="isMenuOpen = !isMenuOpen" :class="{ active: isMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
      
      <!-- 导航菜单 -->
      <nav :class="{ 'nav-active': isMenuOpen }">
        <ul class="nav-links">
          <li v-for="nav in navItems" :key="nav.name">
            <router-link :to="nav.path" class="nav-item" @click="closeMenu">
              <span class="nav-zh">{{ nav.name }}</span>
              <span class="nav-en">{{ nav.en }}</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isMenuOpen: false,
      navItems: [
        { name: '首页', en: 'Home', path: '/' },
        { name: '关于我们', en: 'About', path: '/about' },
        { name: '生日卡券', en: 'Birthday Card', path: '/service' },
        { name: '悦影时光', en: 'Movie Time', path: '/cases' },
        { name: '年节礼包', en: 'Gift Pack', path: '/news' },
        { name: '悦动态', en: 'Yue Dynamic', path: '/contact' },
        { name: '工会消费券', en: 'Consumption coupon', path: '/coupon' },
      ]
    }
  },
  methods: {
    homes() {
      window.location.href = 'http://www.bjfmm.com/#/'
    },
    closeMenu() {
      this.isMenuOpen = false
    }
  }
}
</script>

<style scoped>
.header {
  background: rgba(255, 255, 255, 0.97);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.06);
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ========== 桌面端导航样式 ========== */
.nav-links {
  display: flex;
  list-style: none;
  gap: 0;
  margin: 0;
  padding: 0;
}

.nav-links li {
  position: relative;
}

.nav-links li+li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 20px;
  background: #e0e0e0;
}

.nav-item {
  text-decoration: none;
  font-family: 'Microsoft YaHei', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
  line-height: 1.4;
  height: 56px;
  overflow: hidden;
}

.nav-zh,
.nav-en {
  display: block;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.6s ease;
}

/* 默认：中文在上，英文在下 */
.nav-zh {
  font-size: 16px;
  color: #353535;
  transform: translateY(11px);
}

.nav-en {
  font-size: 14px;
  color: #666;
  transform: translateY(11px);
}

/* hover：中文下移，英文上移，交换位置 */
.nav-item:hover .nav-zh {
  transform: translateY(33px);
  color: #c40000;
}

.nav-item:hover .nav-en {
  transform: translateY(-11px);
  color: #c40000;
}

/* 当前激活路由样式 */
.nav-item.router-link-exact-active .nav-zh,
.nav-item.router-link-exact-active .nav-en {
  color: #c40000;
}

/* 激活状态下保持英文在上、中文在下 */
.nav-item.router-link-exact-active .nav-zh {
  transform: translateY(33px);
}

.nav-item.router-link-exact-active .nav-en {
  transform: translateY(-11px);
}

/* ========== 移动端汉堡菜单按钮 ========== */
.mobile-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 101;
}

.mobile-toggle span {
  display: block;
  width: 100%;
  height: 3px;
  background: #353535;
  border-radius: 3px;
  transition: all 0.3s ease;
}

/* 汉堡菜单激活动画 */
.mobile-toggle.active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.mobile-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-toggle.active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

/* ========== 移动端响应式 ========== */
@media (max-width: 768px) {
  .mobile-toggle {
    display: flex;
  }

  .logo img {
    width: 140px !important;
  }

  nav {
    position: fixed;
    top: 0;
    right: -380px;
    width: 280px;
    height: 100vh;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: -5px 0 30px rgba(0, 0, 0, 0.1);
    padding: 80px 20px 20px;
    transition: right 0.3s ease;
    z-index: 100;
    overflow-y: auto;
  }

  nav.nav-active {
    right: 0;
  }

  .nav-links {
    flex-direction: column;
    gap: 0;
  }

  .nav-links li {
    border-bottom: 1px solid #f0f0f0;
  }

  /* 移除桌面端分隔线 */
  .nav-links li+li::before {
    display: none;
  }

  .nav-item {
    flex-direction: row;
    justify-content: flex-start;
    gap: 10px;
    padding: 15px 10px;
    height: auto;
    overflow: visible;
  }

  /* 移动端取消上下交换动画，改为水平排列 */
  .nav-zh,
  .nav-en {
    transform: translateY(0) !important;
  }

  .nav-zh {
    font-size: 16px;
    font-weight: 500;
  }

  .nav-en {
    font-size: 12px;
    color: #999;
  }

  /* 移动端激活样式 */
  .nav-item.router-link-exact-active {
    background: rgba(196, 0, 0, 0.05);
    border-radius: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/head.vue